import { render, staticRenderFns } from "./RecipientsField.vue?vue&type=template&id=4e7a08c5"
import script from "./RecipientsField.vue?vue&type=script&lang=js"
export * from "./RecipientsField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports